<template>
  <LcHeader
    headline-class="headline-h3-headline"
    @left-button-click="navigateBack"
  >
    <template #headline>
      <template v-if="loading">
        <LcSkeleton height="1.875rem" radius="medium" width="40%" />
      </template>
      <template v-else>
        {{ title }}
      </template>
    </template>

    <slot />
  </LcHeader>
</template>

<script lang="ts" setup>
defineProps<{ loading?: boolean; title: string }>()

const { navigateBack } = useRouterUtils()
</script>
